import "./Capsules.module.css";
import CorporateCoffeeCapsulesAndMachines from "@/reusable_sections/Header";
import NosGammesDeCapsules from "./sections/NosGammesDeCapsules";
import Products from "./sections/Products";
export default function CapsulesPage() {
  return <div>
      <CorporateCoffeeCapsulesAndMachines />
      <NosGammesDeCapsules />
      <Products />
    </div>;
}